import styles from './styles.module.css';

interface IZoomSwitchProps<T extends string> {
  /** Currently selected option. */
  value: T;
  /** Ordered options rendered as segments. */
  options: readonly T[];
  /** Resolve the (already-localized) label for an option. */
  getLabel: (option: T) => string;
  /** Accessible label for the radiogroup. */
  ariaLabel: string;
  onChange: (option: T) => void;
}

/** Segmented day/week/month-style switch (a radiogroup of pill buttons). Shared
 *  by the Scheduler toolbar and the dashboard Master Schedule card so the
 *  granularity control looks and behaves identically across surfaces. */
export function ZoomSwitch<T extends string>({ value, options, getLabel, ariaLabel, onChange }: IZoomSwitchProps<T>) {
  return (
    <div className={styles.group} role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={value === option}
          className={`${styles.button} ${value === option ? styles.active : ''}`}
          onClick={() => onChange(option)}
        >
          {getLabel(option)}
        </button>
      ))}
    </div>
  );
}
